import { render, staticRenderFns } from "./SmartPillboxList.vue?vue&type=template&id=b92c8fb2&scoped=true"
import script from "./SmartPillboxList.vue?vue&type=script&lang=js"
export * from "./SmartPillboxList.vue?vue&type=script&lang=js"
import style0 from "./SmartPillboxList.vue?vue&type=style&index=0&id=b92c8fb2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b92c8fb2",
  null
  
)

export default component.exports